// @flow

import React from 'react';
import { connect } from 'react-redux';
import DirectContact from './directContact';
import { mapContactOptions } from '../../store/settings/selectors';
import type { ACFContactOption, EnrichedContactOption } from './types';

type OwnProps = {|
  acfContactOptions: Array<ACFContactOption>, // eslint-disable-line react/no-unused-prop-types
|};

type StateProps = {|
  contactOptions: Array<EnrichedContactOption>,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const DirectContactContainer = ({
  acfContactOptions, // prevent this from being passed on
  contactOptions,
  ...rest
}: Props) => (
  <DirectContact
    contactOptions={contactOptions}
    {...rest}
  />
);

const mapStateToProps = (state: any, ownProps: OwnProps): StateProps => ({
  contactOptions: mapContactOptions(state)(ownProps.acfContactOptions),
});

export default connect<any, OwnProps, StateProps, any, any, any>(
  mapStateToProps,
)(DirectContactContainer);
